import React from "react";

const MapIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="38" viewBox="0 0 30 38"><path d="M23 0c-8.28.01-14.989 6.384-15 14.25 0 10.23 13.975 23.043 14.569 23.584a.642.642 0 0 0 .862 0c.594-.541 14.569-13.354 14.569-23.584-.011-7.866-6.72-14.24-15-14.25zm0 20.781a6.71 6.71 0 0 1-6.875-6.531 6.71 6.71 0 0 1 6.875-6.531 6.71 6.71 0 0 1 6.875 6.531 6.714 6.714 0 0 1-6.875 6.531z" fill={props.fill} transform="translate(-8)"/></svg>
    )
}

export default MapIcon;